import { Injectable } from '@angular/core';

import OAuthInfo from '@arcgis/core/identity/OAuthInfo';
import esriId from '@arcgis/core/identity/IdentityManager.js';

@Injectable({ providedIn: 'root' })
export class ArcgisAuthService {
	private _authInfo: OAuthInfo;

	constructor() {
		this._authInfo = new OAuthInfo({
			appId: (window as any).gis.appId,
			portalUrl: 'https://gis.israntique.org.il/portal',
			popup: false,
			flowType: 'implicit',
			locale: 'he',
		});
		if (!esriId.findOAuthInfo(this._authInfo.portalUrl)) {
			esriId.registerOAuthInfos([this._authInfo]);
		}
	}

	singIn() {
		esriId
			.checkSignInStatus(this._authInfo.portalUrl + '/sharing')
			.then(() => {
				console.log('User already signed in');
			})
			.catch(() => {
				esriId
					.getCredential(this._authInfo.portalUrl + '/sharing')
					.then((credential: any) => {
						console.log('Signed in:', credential.userId);
					});
			});
	}
}
